import './src/css/global.css'
import * as Sentry from '@sentry/gatsby'

// Sentryへ送るURL/文字列から認証トークンを除去する。
// /at?t=<token> ・ /authorize?token=<token> はトークンがURLに乗るため、
// 既定のHttpContext integrationが window.location.href（=有効トークン）を
// event.request.url として送信してしまう（レビューP1）。breadcrumbs内のURLも同様。
const maskAuthTokenInUrl = (value) => {
  if (typeof value !== 'string') return value
  return value.replace(
    /([?&](?:t|token|session_token)=)[^&#]+/gi,
    '$1[Filtered]',
  )
}

const maskAuthTokenDeep = (obj) => {
  if (!obj || typeof obj !== 'object') return obj
  Object.keys(obj).forEach((key) => {
    const v = obj[key]
    if (typeof v === 'string') {
      obj[key] = maskAuthTokenInUrl(v)
    } else if (v && typeof v === 'object') {
      maskAuthTokenDeep(v)
    }
  })
  return obj
}

export const onClientEntry = () => {
  Sentry.init({
    dsn: 'https://c601cdbc912a4c8384546a87ef8fde3c@o283046.ingest.sentry.io/4504960779157504',
    environment: process.env.GATSBY_ACTIVE_ENV,
    normalizeDepth: 15,
    enabled: (() =>
      ['production', 'staging'].indexOf(process.env.GATSBY_ACTIVE_ENV) !==
      -1)(),
    beforeSend: (event) => maskAuthTokenDeep(event),
    beforeBreadcrumb: (breadcrumb) => maskAuthTokenDeep(breadcrumb),
  })
}
